"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var RadioGroup = function (props) {
    var selectedValue = props.selectedValue, inline = props.inline, block = props.block, hideRadios = props.hideRadios, children = props.children, className = props.className, style = props.style, handleOnChange = props.onChange;
    var radioElmsClone = React.Children.map(children, function (child, index) {
        if (!React.isValidElement(child)) {
            return null;
        }
        var childEl = child;
        return React.cloneElement(childEl, {
            index: index,
            onChange: handleOnChange,
            checked: selectedValue === childEl.props.value,
            hideRadio: hideRadios,
            block: block
        });
    });
    var classes = classNames('form-group__radio-group', className);
    var styles = __assign({}, style);
    if (inline) {
        styles = __assign({ display: 'flex' }, styles);
    }
    return (React.createElement("div", { className: classes, style: styles }, radioElmsClone));
};
exports.default = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/RadioGroup/RadioGroup.js
// module id = 275
// module chunks = 0